import store from "@/store/index"
import moment from "moment-timezone"

const dateTimeUtils = {
  universalTimeZoneFormatter: ({
    dateTime,
    inputTimezone = "UTC", // can be 'UTC' | 'school' | 'America/New_York' etc. Default is UTC.
    outputTimezone = store?.getters?.["schools/activeSchoolTimeZone"],
    inputFormat = "YYYY-MM-DD HH:mm:ss",
    outputFormat = "MM-DD-YYYY h:mm A"
  }) => {
    // If inputTimezone is 'school', override it with school timezone
    const resolvedInputTimezone =
      inputTimezone === "school"
        ? store?.getters?.["schools/activeSchoolTimeZone"]
        : inputTimezone

    const formattedDateTime = moment
      .tz(dateTime, inputFormat, resolvedInputTimezone)
      .tz(outputTimezone)
      .format(outputFormat)

    return formattedDateTime
  }
}

export default dateTimeUtils
